import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon, Input } from 'semantic-ui-react';

import GeoClosestLocation from '../../darkmatter/GeoClosestLocation';
import Location from '../../molecules/Location';
import SortByDistanceButton from './components/SortByDistanceButton';
import SearchLocations from './components/SearchLocations';
import './LocationsSorted.css';

export default class LocationsSorted extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: props.locations,
      searchQuery: '',
      startOrderByDistance: false,
    };

    this.applyFilter = this.applyFilter.bind(this);
    this.onStartSortByDistance = this.onStartSortByDistance.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  applyFilter(locations = []) {
    const { searchQuery } = this.state;

    let filteredLocations = locations;

    if (searchQuery && searchQuery.length) {
      const re = new RegExp(searchQuery, 'i');

      filteredLocations = locations.filter(loc => {
        const keys = Object.keys(loc);
        for (let i = 0; i < keys.length; i += 1) {
          const key = keys[i];
          if (key !== 'id' && typeof loc[key] !== 'object' && re.test(loc[key])) {
            return true;
          }
        }
        return false;
      });
    }

    return filteredLocations;
  }

  onStartSortByDistance() {
    this.setState({ startOrderByDistance: true });
  }

  onSearchChange(e) {
    this.setState({ searchQuery: e.target.value }, this.applyFilter);
  }

  render() {
    const {
      locations,
      searchHeader,
      searchHeaderAs,
      searchPlaceholder,
      verticalAlign,
      horizontalAlign,
      className,
      showIcon,
      distanceUnit,
      map,
    } = this.props;
    const { searchQuery, startOrderByDistance } = this.state;

    return (
      <>
        <GeoClosestLocation
          start={startOrderByDistance}
          locations={locations}
          distanceUnit={distanceUnit}
        >
          {({ loading, locations: geoClosestLocations, state: geoClosestLocationStatus }) => {
            const filteredLocations = this.applyFilter(geoClosestLocations);
            const noResults = filteredLocations.length === 0;

            return (
              <Grid
                id="location-grid"
                stackable
                className={className}
                verticalAlign={verticalAlign}
                textAlign={horizontalAlign}
              >
                <Grid.Row>
                  <Grid.Column width={16}>
                    <SearchLocations
                      onSearchChange={this.onSearchChange}
                      searchHeader={searchHeader}
                      searchHeaderAs={searchHeaderAs}
                      searchQuery={searchQuery}
                      searchPlaceholder={searchPlaceholder}
                      locationSortingStatus={geoClosestLocationStatus}
                      onSort={this.onStartSortByDistance}
                      distanceLoading={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  {noResults && (
                    <p style={{ color: 'gray' }}>
                      No results found for the search "{searchQuery}
                      ".
                    </p>
                  )}
                  {filteredLocations.map(loc => (
                    <Grid.Column
                      id={loc.id}
                      computer={8}
                      tablet={8}
                      mobile={16}
                      className="location-filter-location-detail"
                    >
                      <Location
                        address={{
                          street: loc.street,
                          city: loc.city,
                          state: loc.state,
                          zip: loc.zipCode,
                          country: loc.country,
                        }}
                        timezone={loc.timezone}
                        hours={loc.hours}
                        phone={loc.phoneNumber}
                        as="card"
                        showAddress
                        showIcon={showIcon}
                        showMap={filteredLocations.length === 1}
                        {...loc}
                      />
                    </Grid.Column>
                  ))}
                </Grid.Row>
              </Grid>
            );
          }}
        </GeoClosestLocation>
      </>
    );
  }
}

LocationsSorted.propTypes = {
  searchHeader: PropTypes.string,
  searchHeaderAs: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      hours: PropTypes.array,
      street: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
      country: PropTypes.string,
      latitude: PropTypes.string,
      longitude: PropTypes.string,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          icon: PropTypes.string,
          label: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  verticalAlign: PropTypes.string,
  horizontalAlign: PropTypes.string,
  showIcon: PropTypes.bool,
};

LocationsSorted.defaultProps = {
  locations: [],
  searchHeader: 'Search Our Locations',
  searchHeaderAs: 'h2',
  searchPlaceholder: '123 Main Street, Boston MA',
  verticalAlign: 'center',
  horizontalAlign: 'center',
  showIcon: true,
  map: false,
};
